/**
 * Cross-slice cache invalidation: config/rule create/update/delete can
 * change the org resource-label catalog, but those mutations live on
 * separate `createApi` instances and cannot invalidate `resourceLabelsApi`
 * tags directly. Without this bridge, LabelEditor autocomplete and the
 * Configure label filters keep a stale (often empty) catalog after the first
 * fetch.
 */

import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'

import { customAgentsApi } from '../agents/custom-agents'
import { notificationRulesApi } from '../notification-rules'
import { resourceLabelsApi } from './resource-labels-api'

export const resourceLabelsBridge = createListenerMiddleware()

resourceLabelsBridge.startListening({
  matcher: isAnyOf(
    customAgentsApi.endpoints.createCustomAgentConfig.matchFulfilled,
    customAgentsApi.endpoints.updateCustomAgentConfig.matchFulfilled,
    customAgentsApi.endpoints.deleteCustomAgentConfig.matchFulfilled,
    notificationRulesApi.endpoints.createNotificationRule.matchFulfilled,
    notificationRulesApi.endpoints.updateNotificationRule.matchFulfilled,
    notificationRulesApi.endpoints.deleteNotificationRule.matchFulfilled
  ),
  effect: (_action, api) => {
    api.dispatch(resourceLabelsApi.util.invalidateTags([{ type: 'ResourceLabel', id: 'LIST' }]))
  }
})
